
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaGalleryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoGalleryImageConnection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hotelView"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"suites"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"guestRooms"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"weddings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"eventsAndMeetings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"dining"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"recreationAndFitness"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"golf"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nearbyAttractions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"spa"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"villas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoenixGroupsPropertyMediaFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":975}};
    doc.loc.source = {"body":"#import \"./propertyMediaFragment.graphql\"\n\nfragment PhoenixGroupsPropertyMediaGalleryFragment on PhotoGalleryImageConnection {\n  hotelView {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  suites {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  guestRooms {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  weddings {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  eventsAndMeetings {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  dining {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  features {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  recreationAndFitness {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  golf {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  nearbyAttractions {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  services {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  spa {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  villas {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n  activities {\n    ...PhoenixGroupsPropertyMediaFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./propertyMediaFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PhoenixGroupsPropertyMediaGalleryFragment"] = oneQuery(doc, "PhoenixGroupsPropertyMediaGalleryFragment");
        
